"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addFiltersToSearchParams = addFiltersToSearchParams;
exports.checkQuickFilterAvailability = checkQuickFilterAvailability;
exports.getFilterURLParams = getFilterURLParams;
exports.getQuickAppliedFilter = getQuickAppliedFilter;
exports.getQuickAppliedFilters = getQuickAppliedFilters;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _helpers = require("../helpers.utils");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _filters = require("../../constants/filters.constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getFilterURLParams() {
  var urlParams = {};
  if ((0, _helpers.isCSR)()) {
    var _window$location;
    urlParams = _queryString.default.parse((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.search);
  }
  return urlParams;
}
function addFiltersToSearchParams(query, filtersQuery) {
  var searchParams = (0, _omit2.default)(query, (0, _values2.default)(_filters.FILTER_PARAM_MAP));
  var filterParams = (0, _pickBy2.default)(filtersQuery);
  return _objectSpread(_objectSpread({}, searchParams), filterParams);
}
var getAirlineQuickFilter = function getAirlineQuickFilter(filter) {
  return (0, _map2.default)(filter.params, function (param) {
    return {
      id: param,
      filter: _filters.FILTER_MAP.AIRLINE,
      toggleMethod: "toggle",
      payload: [param],
      isActive: true,
      label: filter.flightInfo.$resources.getAirlineLabel(param),
      isAvailable: true
    };
  });
};
var getStopQuickFilter = function getStopQuickFilter(filter) {
  return (0, _filter2.default)((0, _map2.default)(filter.params, function (param) {
    var numberParam = Number(param);
    if (numberParam !== _filters.STOP_FILTER_CODE_MAP.DIRECT_ONLY) {
      return {
        id: param,
        filter: _filters.FILTER_MAP.STOP,
        toggleMethod: "reset",
        payload: numberParam,
        isActive: true,
        label: param,
        isAvailable: true
      };
    }
  }), function (filter) {
    return !!filter;
  });
};
function transformAirportFilterParams(leg, filter, index) {
  var origins = leg.origin.map(function (code) {
    return {
      id: code + "_" + index + "-" + _filters.FLIGHT_LEG_TYPE_MAP.ORIGIN,
      filter: _filters.FILTER_MAP.AIRPORT,
      toggleMethod: "toggle",
      payload: {
        index: index,
        type: _filters.FLIGHT_LEG_TYPE_MAP.ORIGIN,
        code: code
      },
      isActive: true,
      label: filter.flightInfo.$resources.getAirportLabel(code),
      isAvailable: true
    };
  });
  var destinations = leg.destination.map(function (code) {
    return {
      id: code + "_" + index + "-" + _filters.FLIGHT_LEG_TYPE_MAP.DESTINATION,
      filter: _filters.FILTER_MAP.AIRPORT,
      toggleMethod: "toggle",
      payload: {
        index: index,
        type: _filters.FLIGHT_LEG_TYPE_MAP.DESTINATION,
        code: code
      },
      isActive: true,
      label: filter.flightInfo.$resources.getAirportLabel(code),
      isAvailable: true
    };
  });
  return [].concat(origins, destinations);
}
function transformTimeFilterParams(leg, index) {
  var origins = leg.origin.map(function (code) {
    return {
      id: code + "_" + index + "-" + _filters.FLIGHT_LEG_TYPE_MAP.ORIGIN,
      filter: _filters.FILTER_MAP.TIME,
      toggleMethod: "toggle",
      payload: {
        index: index,
        type: _filters.FLIGHT_LEG_TYPE_MAP.ORIGIN,
        code: code
      },
      isActive: true,
      isAvailable: true
    };
  });
  var destinations = leg.destination.map(function (code) {
    return {
      id: code + "_" + index + "-" + _filters.FLIGHT_LEG_TYPE_MAP.DESTINATION,
      filter: _filters.FILTER_MAP.TIME,
      toggleMethod: "toggle",
      payload: {
        index: index,
        type: _filters.FLIGHT_LEG_TYPE_MAP.DESTINATION,
        code: code
      },
      isActive: true,
      isAvailable: true
    };
  });
  return [].concat(origins, destinations);
}
var getAirportQuickFilter = function getAirportQuickFilter(filter) {
  return (0, _flatMap2.default)(filter.params, function (param, index) {
    return transformAirportFilterParams(param, filter, index);
  });
};
var getTimeQuickFilter = function getTimeQuickFilter(filter) {
  return (0, _flatMap2.default)(filter.params, function (param, index) {
    return transformTimeFilterParams(param, index);
  });
};
var getPriceQuickFilter = function getPriceQuickFilter(filter) {
  if (filter.isDirty) {
    return [{
      id: _filters.FILTER_MAP.PRICE,
      filter: _filters.FILTER_MAP.PRICE,
      toggleMethod: "reset",
      isActive: true,
      payload: filter.params,
      isAvailable: true
    }];
  }
};
function getQuickAppliedFilter(filter) {
  switch (filter.id) {
    case _filters.FILTER_MAP.AIRLINE:
      return getAirlineQuickFilter(filter);
    case _filters.FILTER_MAP.STOP:
      return getStopQuickFilter(filter);
    case _filters.FILTER_MAP.AIRPORT:
      return getAirportQuickFilter(filter);
    case _filters.FILTER_MAP.TIME:
      return getTimeQuickFilter(filter);
    case _filters.FILTER_MAP.PRICE:
      return getPriceQuickFilter(filter);
    default:
      return [];
  }
}
function getQuickAppliedFilters(appliedFilters, topAirlinesQuickFilters) {
  return (0, _filter2.default)(appliedFilters, function (filter) {
    return !!filter && !topAirlinesQuickFilters.find(function (topAirlinesQuickFilter) {
      return topAirlinesQuickFilter.id === filter.id;
    });
  });
}
function checkQuickFilterAvailability(filter) {
  var _codeMap;
  var codeMap = (_codeMap = {}, _codeMap[_filters.FILTER_MAP.STOP] = _filters.STOP_FILTER_CODE_MAP.DIRECT_ONLY, _codeMap[_filters.FILTER_MAP.BAGGAGE] = _filters.BAGGAGE_FILTER_CODE_MAP.HAS_CHECKED_BAGGAGE, _codeMap);
  return !!(0, _find2.default)(filter.state, {
    code: codeMap[filter.id],
    isAvailable: true
  });
}